import { useTheme } from '../theme/ThemeContext';
import FormLabel from './FormLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LabeledField = ({
  htmlFor,
  label,
  required,
  labelLayout = 'block',
  children
}) => {
  const theme = useTheme();
  const isInline = labelLayout === 'inline';
  const containerStyle = isInline ? {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing['200']
  } : {};
  const labelStyle = isInline ? {
    flexShrink: 0
  } : {
    display: 'block',
    marginBottom: theme.spacing['100']
  };
  return /*#__PURE__*/_jsxs("div", {
    style: containerStyle,
    children: [label && /*#__PURE__*/_jsx(FormLabel, {
      label: label,
      required: required,
      htmlFor: htmlFor,
      style: labelStyle
    }), children]
  });
};
export default LabeledField;